import { toast } from "react-toastify";
import { fetchUserIp, loadColorConfig } from "../constants/common";
import API from "../services";
import { setActiveWallet, setExchangeAuthData, setSportBookAuthData, setUserDetails, setUserThumbnail, setWallets, setColorConfig, setSiteConfig } from "./authReducer";
import { setIsCashoutEnabled, setTurboCashoutCommission } from "./exchangeSports/exchangeSportsReducer";
import { ColorConfig, UserDetails } from "../models/UserDetails";
import { themes } from "../components/WalletComponents/MyProfile/MyProfile";
import { DateRange } from "../App";
import TOKEN_API from "../services/token";
import { SiteConfig } from "../models/SiteConfig";
import store from "./store";


export const getGameUrl = (provider: string) => {
  return async (dispatch: Function) => {
    try {
      const userIp = await fetchUserIp();
      const response = await API.post(`/webapp/get-login-url`, {
        userKey: sessionStorage.getItem("userKey"),
        tgProviderId: provider,
        clientIp: userIp,
      });

      if (response.data.status !== "RS_OK") {
        toast.error(response.data.errorDescription);
        return Promise.reject(response.data.errorDescription);
      }

      if (response.data?.sessionUrl !== "") {
        const isCashoutEnabled = response.data?.isCashoutEnabled ?? false;
        const cashoutCommission = response.data?.cashoutCommission ?? 0;
        await setSportsAuthData(dispatch, provider, response.data.sessionUrl, isCashoutEnabled, cashoutCommission);
      }
      return Promise.resolve(response.data.sessionUrl);
    } catch (e) {
      console.error("API Error:", e);
      toast.error("Failed to get game URL. Please try again.");
      return Promise.reject(e);
    }
  };
};

export const getUserBalance = () => async (dispatch: any) => {
  let response: any;
  try {
    response = await API.post(`/webapp/get-user-balance`, {
      userKey: sessionStorage.getItem("userKey"),
    });
  } catch (e) {
    return;
  }

  // if (response.data.status !== "RS_OK") {
  //   toast.error(response.data.errDescription);
  // }

  if (response && response.data.wallets) {
    dispatch(setWallets(response.data?.wallets));
    dispatch(setActiveWallet(response?.data?.activeWallet))
  }
};

export const getRefId = () => async (dispatch: any) => {
  try {
    const userKey = sessionStorage.getItem("userKey");
    if (!userKey) {
      console.error("User ID not found in session storage");
      return;
    }
    const response = await API.post(`/users/get-user-details`, {
      userKey: userKey,
    });

    if (!response || response.data.status !== "RS_OK") {
      console.error("Error retrieving user details or invalid status");
      return;
    }

    const fetchedUserDetails: UserDetails = response.data?.userDetails;
    const fetchedColors: ColorConfig=response.data?.colorConfig;

    const validThemes = [
      'blue', 'purple', 'green', 'yellow', 'orange', // Existing themes
      'CSK', 'DC', 'GT', 'KKR', 'LSG', 'MI', 'PK', 'RR', 'RCB', 'SRH' // IPL Teams
    ] as const;
    type ThemeType = typeof validThemes[number];
    if (fetchedColors) {
      dispatch(setColorConfig(fetchedColors));
    }

    if (fetchedUserDetails) {
      dispatch(setUserDetails(fetchedUserDetails));
      if (fetchedUserDetails?.UserKey !== userKey) {
        sessionStorage.setItem("userKey", fetchedUserDetails?.UserKey);
      }
      dispatch(setUserThumbnail(fetchedUserDetails?.Thumbnail));
      // if (fetchedUserDetails?.disableDefaultTheme || fetchedUserDetails.Theme == 'default'){
      //   setReposneTheme(fetchedColors)
      // }else if (validThemes.includes(fetchedUserDetails.Theme as ThemeType)) {
      //   setTheme(fetchedUserDetails.Theme as ThemeType);
      // } else {
      //   setTheme('blue');
      // }
    } else {
      console.error("User details not found in response");
    }
  } catch (error) {
    console.error("Error fetching user details:", error);
  }
};

const setTheme = (themeName: keyof typeof themes) => {
  const selectedTheme = themes[themeName];

  if (selectedTheme) {
    loadColorConfig(selectedTheme)
  } else {
    console.error('Theme not found');
  }
};

const setReposneTheme = (colors: ColorConfig) => {
  const selectedTheme = {
    inputboxColor:colors.inputBackgroundBox,
    appbgColor: colors.background,
    headerColor: colors.primary,
    filterColor: colors.filterColor,
    tablebg: colors.tableBackground,
    tableHeader: colors.tableHeader,
    tableHeadCellBorder: colors.tableBorder,
    marketTableBg: colors.tableBackground,
    ionColorPrimary: colors.primaryTeamInfo,
    teamInfoBackground: colors.backgroundTeamInfo,
    borderColor:colors.primary,
    backgroundCard:colors.tableBackground,
    meitmsColor: `${colors.primary}50`,
  };
  loadColorConfig(selectedTheme)
};


const setSportsAuthData = async (dispatch: Function, provider: string, url: string, isCashoutEnabled: boolean, cashoutCommission: number) => {
  return new Promise((resolve) => {
    const parsedUrl = new URL(url);

    const authData = {
      token: parsedUrl.searchParams.get("token"),
      operatorId: parsedUrl.searchParams.get("operatorId"),
      partnerId: parsedUrl.searchParams.get("partnerId"),
      providerId: parsedUrl.searchParams.get("providerId"),
      currency: parsedUrl.searchParams.get("currency"),
      rate: parseFloat(parsedUrl.searchParams.get("rate") || "1"),
    };

    let userDetails = store.getState().userDetails.userDetails;

    // Set the extracted data
    if (provider === userDetails?.exchangeProvider) {
      dispatch(setIsCashoutEnabled(isCashoutEnabled));
      dispatch(setTurboCashoutCommission(cashoutCommission));
      dispatch(setExchangeAuthData(authData));
    } else {
      dispatch(setSportBookAuthData(authData));
    }

    resolve(true);
  });
};

export function setTextColor(hexColor: any) {
  var r = parseInt(hexColor.substring(1, 3), 16);
  var g = parseInt(hexColor.substring(3, 5), 16);
  var b = parseInt(hexColor.substring(5, 7), 16);
  var yiq = (r * 299 + g * 587 + b * 114) / 1000;

  return yiq >= 186 ? "dark-text" : "light-text";
}

export const setUserSportsView = (isClassic: boolean) => {
  try {
    let result = null;
    result = API.post(`/users/change-sports-view`, {
      isClassic: isClassic,
    });

  } catch (err) {
    console.log(err);
  }
};

const decodeBase64 = (base64: string) => {
  try {
    const decodedString = atob(base64); // Decode Base64
    return JSON.parse(decodedString); // Convert to JSON
  } catch (error) {
    console.error("Error decoding Base64:", error);
    return null;
  }
};

export const BannerNavigation = (redirectUrl: string, navigate: (path: string, state?: any) => void) => {

  const jsonData = decodeBase64(redirectUrl);

  if (jsonData && jsonData.page) {
    const { page, ...rest } = jsonData;

    switch (page.toLowerCase()) {
      case "event":
        if (rest.id && rest.name && rest.lobby) {
          navigate(`/events/${btoa(`${rest.id}#${rest.name}#${rest.lobby}`)}`);
        }
        break;

      case "market":
        if (rest.id && rest.lobby) {
          const marketPath = rest.lobby.toUpperCase() === "SPORTSBOOK"
            ? `/sb-markets/${btoa(`${rest.id}`)}`
            : `/markets/${btoa(`${rest.id}`)}`;
          sessionStorage.setItem("previousPath", "/sports");
          navigate(marketPath);
        }
        break;

      case "customersupport":
        navigate(`/customersupport`)
        break;
      case "bonus":
        navigate("/wallet", { state: {bpCategory: rest?.bonus_category, bpType: rest?.bonus_type, tId: rest?.transaction_id, amount: rest?.amount, curType: rest?.currency?.type, curCategory: "", dateRange: rest?.date_range as DateRange | undefined, tab: "bonus", policyId: rest?.bonus_policy_id } });
        break;
      case "ticket-details":
        navigate("/ticket-details", { state: { ticketId: rest?.ticketId } });
        break;
      case "playgame":
        navigate(`/play/${btoa(`${rest?.id}:${rest?.id}:${rest?.tgProviderId}:${rest?.provider}:${rest?.subProvider}:${rest?.type}:${rest?.category}:${rest?.tableId ? rest?.tableId : ""}:${false}:${false}`)}`)
        break;
      case "home":
        navigate(`/home`)
        break;
      case "casino":
        navigate(`/casino`)
        break;
      case "sports":
        navigate(`/sports`)
        break;
      case "site":
        navigate(`/promotions`, { state: { Pagetab: "site" } })
        break;
      case "wallet":
        navigate(`/wallet`)
        break;
      case "promotions":
        navigate(`/promotions`, { state: { Pagetab: "promotions" } })
        break;
      case "providergames":
        const prov = {
          provider: rest?.provider,
          subProvider: rest?.subProvider,
          tgProviderId: rest?.tgProviderId,
          thumbnail: rest?.thumbnail,
        }
        sessionStorage.setItem("previousPath", "/casino");
        navigate("/providergames", { state: { prov } });
        break;
      case "profilepage":
        sessionStorage.setItem("previousPath", "/profile");
        if (rest?.profileOption) {
          switch (rest?.profileOption) {
            case "myprofile":
              navigate(`/myprofile`)
              break;
            case "transactions":
              navigate(`/transactions`)
              break;
            case "accountstatement":
              navigate(`/account-statement`)
              break;
            case "faq":
              navigate(`/faq`)
              break;
            case "betlist":
              navigate(`/betlist`)
              break;
          }
        }
        break;
      default:
        console.warn("Unknown page type or missing required fields:", jsonData);
    }
  }
};

export const siteConfig = () => async (dispatch: any) => {
  try {
    const response = await TOKEN_API.post(`/api/v1/auth/group-config`, {
    });

    if (!response || response.data.status !== "RS_OK") {
      console.error("Error retrieving user details or invalid status");
      return;
    }

    // const fetchedUserDetails: UserDetails = response.data?.userDetails;
    const fetchedSiteConfig: SiteConfig = response.data;

    if (fetchedSiteConfig) {
      dispatch(setSiteConfig(fetchedSiteConfig));
    } else {
      console.error("User details not found in response");
    }
  } catch (error) {
    console.error("Error fetching user details:", error);
  }
};